export default __webpack_public_path__ + "static/media/Ballroll_00196.315dfe78.png";